import React, { useCallback } from 'react';
import Carousel from './Carousel';

import ImageBlurFallback from '../../Components/ImageBlurFallback';
import { CLIENT_URL_IMAGE } from '../../config.local';

import { splitData } from '../../helpers/helper';

const MobileHighlihghts = ({ data = [], images = [] }) => {
  if (!data || !data.length || !images || !images.length) {
    return null;
  }

  const modifiedData = splitData(data, 3);
  const modifiedImages = splitData(images, 3);

  const getImageUrl = useCallback(
    (url) => {
      if (url) {
        return `${CLIENT_URL_IMAGE}${url}`
      } else {
        return null
      }
    },
    [modifiedImages],
  )

  return (
    <Carousel className="mobile-carousel">
      {modifiedData.map((group, index1) => {
        return (
          <div key={group} className="mobile-highlights-content">
            {group.map((item, index2) => {
              return (
                <HighlightItem
                  key={item}
                  image={modifiedImages[index1] ? getImageUrl(modifiedImages[index1][index2]) : null}
                  text={item}
                />
              );
            })}
          </div>
        );
      })}
    </Carousel>
  );
};

const DesktopHighlights = ({ data, images }) => {
  return (
    data &&
    images &&
    data.length &&
    images.length && (
      <div className="desktop-highlights-content">
        {data.map((item, index) => {
          return (
            <HighlightItem
              key={item}
              image={images[index] ? `${CLIENT_URL_IMAGE}${images[index]}` : null}
              text={item}
            />
          );
        })}
      </div>
    )
  );
};
const HighlightItem = ({ image, text }) => {
  return (
    <div className="highlight-item-container">
      {!!image ?
        <ImageBlurFallback
          className="highlight-item-image"
          src={image}
          alt="course"
        />
        : <div className="highlight-item-imageAlt"></div>
      }
      <span className="highlight-item-text">{text}</span>
    </div>
  );
};

const Highlights = ({ highlights = [], images = [] }) => {
  return highlights && highlights.length ? (
    <section
      className={`highlights-container ${
        highlights.length > 0 ? 'full-height-heighlight' : ''
      }`}>
      <p className="highlights-heading-text">Course Highlights</p>

      <MobileHighlihghts data={highlights} images={images} />
      <DesktopHighlights data={highlights} images={images} />
    </section>
  ) : null;
};

export default Highlights;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Highlights.js